import script from "./expressesSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./expressesSelect.vue?vue&type=script&lang=ts&setup=true"

import "./expressesSelect.vue?vue&type=style&index=0&id=60e22b7d&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e22b7d"]])

export default __exports__